import { useState } from 'react'
import { Box, Typography, FilledInput, IconButton, Grid } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/SearchRounded'
import BookmarkIcon from '@material-ui/icons/Bookmark'
import { useHistory, Link } from 'react-router-dom'

const Home = () => {
    const [word, setWord] = useState('')
    const history = useHistory();

    const handleSubmit = (event) => {
        event.preventDefault()
        const trimmed = word.trim().toLowerCase()
        if (!trimmed.length || trimmed.split(' ').length > 1) return;
        history.push(`/search/${trimmed}`);
    }
    return (
        <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <img src="/assets/book.png" alt="book" />
            <Typography sx={{ mt: 3, mb: 1 }} color="primary" variant="h4">Dictionary</Typography>
            <Typography color="GrayText">Find meanings and save for quick reference</Typography>
            <Box sx={{ width: 360 }} component="form" onSubmit={handleSubmit}>
                <FilledInput
                    value={word}
                    onChange={event => setWord(event.target.value)}
                    autoFocus
                    sx={{
                        mt: 4,
                        borderRadius: 2,
                        backgroundColor: 'white',
                        boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.05)',
                        '& .MuiFilledInput-input': {
                            p: 2,
                        }
                    }} fullWidth disableUnderline
                    placeholder="Enter word"
                    startAdornment={<SearchIcon color="disabled" />}
                />
            </Box>
            <IconButton to="/bookmarks" component={Link} variant="funky" sx={{
                mt: 6
            }}>
                <BookmarkIcon />
            </IconButton>
        </Box>
    )
}

export default Home
